<template>
    <div class="ibox">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "Ibox"
    }
</script>

<style scoped>

</style>
